import * as yup from 'yup';
import { AllergySchema, IAllergy } from './IAllergy';
import { AmputationSchema, IAmputation } from './IAmputation';
import { IVaccine, VaccineSchema } from './IVaccine';

const BaseVitaleSchema = yup.object({
  allergies: yup.array<IAllergy>(AllergySchema).notRequired(),
  vaccines: yup.array<IVaccine>(VaccineSchema).notRequired(),
  amputations: yup.array<IAmputation>(AmputationSchema).notRequired(),
  miscellaneous: yup.string().nullable(),
  weight: yup.number().nullable(),
  height: yup.number().nullable(),
});

export const VitaleSchema = BaseVitaleSchema.concat(
  yup.object({
    residentId: yup.string().notRequired(),
  }),
);

export const UpdateVitalSchema = BaseVitaleSchema.concat(
  yup.object({
    id: yup.string().required(),
  }),
);

export interface IBaseVitale {
  allergies?: IAllergy[];
  vaccines?: IVaccine[];
  amputations?: IAmputation[];
  miscellaneous: string | null;
  weight: number | null;
  height: number | null;
}

export interface IVitale extends IBaseVitale {
  residentId: string;
}

export interface IUpdateVitale extends IBaseVitale {
  id: string;
}
